export const GET_ORDERS_BY_ITEM = "GET_ORDERS_BY_ITEM";
export const GET_CART_ITEMS = "GET_CART_ITEMS";
export const GET_ORDER_INFO = "GET_ORDER_INFO";
export const GET_EVENT_ORDER_ITEMS = "GET_EVENT_ORDER_ITEMS";
export const GET_EVENT_ORDER_ITEM_COUNT = "GET_EVENT_ORDER_ITEM_COUNT";
export const GET_RECOMMEND_EVENT_ON_CART = "GET_RECOMMEND_EVENT_ON_CART";
export const GET_CALENDAR_FRAME_ORDER_ITEMS = "GET_CALENDAR_FRAME_ORDER_ITEMS";
export const GET_CALENDAR_FRAME_ORDER_ITEM_DETAIL =
	"GET_CALENDAR_FRAME_ORDER_ITEM_DETAIL";
export const GET_CALENDAR_CREATED_BY_USER = "GET_CALENDAR_CREATED_BY_USER";
export const GET_SUCCESS_ORDER_ITEMS = "GET_SUCCESS_ORDER_ITEMS";

// Event V2
export const GET_PUBLIC_EVENTS = "GET_PUBLIC_EVENTS";
export const GET_EVENT_BY_SLUG_V2 = "GET_EVENT_BY_SLUG_V2";
export const GET_EVENT_BY_ID_V2 = "GET_EVENT_BY_ID_V2";
export const GET_MINE_EVENTS_V2 = "GET_MINE_EVENTS_V2";
export const GET_REFUND_BY_USER = "GET_REFUND_BY_USER";
export const GET_ALL_REFUND = "GET_ALL_REFUND";
export const GET_REFUND_COUNT_BY_STATUS = "GET_REFUND_COUNT_BY_STATUS";
export const GET_REFUND_COUNT_BY_APPROVAL_STATUS =
	"GET_ALL_REFUND_COUNT_BY_APPROVAL_STATUS";
export const GET_PAYOUT_SUPPORT_LIST = "GET_PAYOUT_SUPPORT_LIST";
export const GET_MY_CO_HOST_EVENTS = "GET_MY_CO_HOST_EVENTS";
export const GET_MY_CO_HOST_EVENTS_COUNTING = "GET_MY_CO_HOST_EVENTS_COUNTING";
export const GET_EVENTS_BY_USERNAME = "GET_EVENTS_BY_USERNAME";
export const GET_PUBLIC_EVENTS_AND_COMBOS = "GET_PUBLIC_EVENTS_AND_COMBOS";
export const GET_PUBLIC_EVENTS_AND_COMBOS_CACHE =
	"GET_PUBLIC_EVENTS_AND_COMBOS_CACHE";
export const GET_USERS_BUYED_TICKETS_EVENT_OFFLINE =
	"GET_USERS_BUYED_TICKETS_EVENT_OFFLINE";
export const EVENT_TRENDING_ON_EVENT_DETAIL = "EVENT_TRENDING_ON_EVENT_DETAIL";
export const EVENT_TRENDING_ON_CART = "EVENT_TRENDING_ON_CART";

// ONLINE COURSE
export const ONLINE_COURSES = "ONLINE_COURSES";
export const GET_ONLINE_COURSE = "GET_ONLINE_COURSE";
export const GET_ONLINE_COURSE_REGISTERED_USERS =
	"GET_ONLINE_COURSE_REGISTERED_USERS";
export const GET_PREVIEW_LESSONS = "GET_PREVIEW_LESSONS";
export const GET_ONLINE_COURSE_AND_COMBO = "GET_ONLINE_COURSE_AND_COMBO";
export const GET_ONLINE_COURSE_AND_COMBO_CACHE =
	"GET_ONLINE_COURSE_AND_COMBO_CACHE";
export const GET_ACADEMY_ONLINE_COURSES = "GET_ACADEMY_ONLINE_COURSES";
export const GET_ACADEMY_ONLINE_COURSES_FAVORITE =
	"GET_ACADEMY_ONLINE_COURSES_FAVORITE";
export const ONLINE_COURSE_DETAIL = "ONLINE_COURSE_DETAIL";
export const ONLINE_COURSE_RECOMMENDATION = "ONLINE_COURSE_RECOMMENDATION";
export const EXPORT_ONLINE_COURSES = "EXPORT_ONLINE_COURSES";
export const EXPORT_ONLINE_COURSE_PROGRESS = "EXPORT_ONLINE_COURSE_PROGRESS";
export const ONLINE_COURSE_LIST_BY_HOST = "online-course-list-by-host";
export const ONLINE_COURSE_LIST_BY_ADMIN = "online-course-list-by-admin";

export const GET_RESKILL_ONLINE_COURSES = "GET_RESKILL_ONLINE_COURSES";
export const GET_LAUNCHPAD_ONLINE_COURSES = "GET_LAUNCHPAD_ONLINE_COURSES";
export const GET_RESKILL_ONLINE_COURSES_FAVORITE =
	"GET_RESKILL_ONLINE_COURSES_FAVORITE";
export const GET_LAUNCHPAD_ONLINE_COURSES_FAVORITE =
	"GET_LAUNCHPAD_ONLINE_COURSES_FAVORITE";
export const GET_ONLINE_COURSE_V2_DETAILED = "GET_ONLINE_COURSE_V2_DETAILED";
export const ONLINE_COURSE_V2_LIST_BY_ADMIN = "ONLINE_COURSE_V2_LIST_BY_ADMIN";
export const DELETE_ONLINE_COURSE_V2_BY_ADMIN =
	"DELETE_ONLINE_COURSE_V2_BY_ADMIN";
export const ENABLE_LND_COURSE = "ENABLE_LND_COURSE";
export const GET_ONLINE_COURSES_LND = "GET_ONLINE_COURSES_LND";
export const GET_COURSE_WITH_PROGRESS = "GET_COURSE_WITH_PROGRESS";

// Combo
export const GET_COMBOS = "GET_COMBOS";
export const GET_COMBOS_BY_USER_ID = "GET_COMBOS_BY_USER_ID";
export const GET_COMBO_BY_ID = "GET_COMBO_BY_ID";
export const GET_COMBO_BY_SLUG = "GET_COMBO_BY_SLUG";
export const GET_COMBO_PRODUCTS = "GET_COMBO_PRODUCTS";
export const GET_COMBO_BUYERS = "GET_COMBO_BUYERS";
export const GET_COMBOS_FOR_PRODUCT = "GET_COMBOS_FOR_PRODUCT";
export const COMBO_DETAIL = "COMBO_DETAIL";
export const COMBO_RECOMMENDATION = "COMBO_RECOMMENDATION";

// Host
export const GET_FOLLOWERS_COUNT = "GET_FOLLOWERS_COUNT";
export const GET_HOST_REGISTER_STATUS = "GET_HOST_REGISTER_STATUS";
export const GET_HOST_PROFILE = "GET_HOST_PROFILE";
export const GET_HOST_LIST = "GET_HOST_LIST";

// User
export const CHECK_IS_NEW_USER_REGISTER = "CHECK_IS_NEW_USER_REGISTER";

// Category
export const GET_CATEGORY_TREE = "GET_CATEGORY_TREE";
export const GET_CATEGORIES_EVENT = "GET_CATEGORIES_EVENT";
export const GET_CATEGORIES_COURSE = "GET_CATEGORIES_COURSE";

// User
export const GET_FOLLOWINGS = "GET_FOLLOWINGS";
export const GET_USERS = "GET_USERS";
export const COUNT_USER_BY_ROLE = "COUNT_USER_BY_ROLE";
export const GET_HOSTS = "GET_HOSTS";
export const CHECK_USER_PAYMENT_METHOD_IN_USE =
	"CHECK_USER_PAYMENT_METHOD_IN_USE";

// Product
export const GET_PRODUCT_VIEWS = "GET_PRODUCT_VIEWS";
export const GET_ELIGIBLE_PRODUCT_VIEWS = "GET_ELIGIBLE_PRODUCT_VIEWS";
export const GET_PRODUCT_ACCESSIBLE = "GET_PRODUCT_ACCESSIBLE";
export const GET_CONTENT_AND_PRODUCTS = "GET_CONTENT_AND_PRODUCTS";

// Membership
export const GET_MAIN_MEMBERSHIP = "GET_MAIN_MEMBERSHIP";
export const GET_MEMBERSHIPS = "GET_MEMBERSHIPS";
export const GET_MEMBERSHIP_WITH_RELATIONS_BY_ID =
	"GET_MEMBERSHIP_WITH_RELATIONS_BY_ID";
export const GET_MEMBERSHIP_LANDING_PAGE_CONTENT =
	"GET_MEMBERSHIP_LANDING_PAGE_CONTENT";
export const GET_MEMBERSHIP_PRICING = "GET_MEMBERSHIP_PRICING";
export const GET_MEMBERSHIP_PRICE_DETAIL = "GET_MEMBERSHIP_PRICE_DETAIL";

// Subscription
export const GET_SUBSCRIPTION_PERIOD_PAYMENT_STATUS =
	"GET_SUBSCRIPTION_PERIOD_PAYMENT_STATUS";
export const GET_SUBSCRIPTION_PAYMENT_SUMMARY =
	"GET_SUBSCRIPTION_PAYMENT_SUMMARY";
export const GET_MY_PAID_SUBSCRIPTIONS = "GET_MY_PAID_SUBSCRIPTIONS";
export const CANCEL_SUBSCRIPTION = "CANCEL_SUBSCRIPTION";
export const CANCEL_NON_PAID_SUBSCRIPTION = "CANCEL_NON_PAID_SUBSCRIPTION";
export const UPDATE_PAYMENT_CARD = "UPDATE_PAYMENT_CARD";
export const UPDATE_SUBSCRIPTION_PLAN = "UPDATE_SUBSCRIPTION_PLAN";
export const GET_PAYMENT_RECORDS = "GET_PAYMENT_RECORDS";
export const GET_MY_SUBSCRIPTIONS = "GET_MY_SUBSCRIPTIONS";
export const GET_PAYMENT_CARDS = "GET_PAYMENT_CARDS";
export const ADD_NEW_PAYMENT_METHOD = "ADD_NEW_PAYMENT_METHOD";
export const GET_SUBSCRIPTION_PAYMENT_CARDS = "GET_SUBSCRIPTION_PAYMENT_CARDS";
export const APPLY_SUBSCRIPTION_VOUCHER = "APPLY_SUBSCRIPTION_VOUCHER";

// Academy
export const GET_ACADEMY_INSTRUCTORS = "GET_ACADEMY_INSTRUCTORS";
export const GET_ACADEMY_CATEGORIES = "GET_ACADEMY_CATEGORIES";
export const GET_ACADEMY_POSTS = "GET_ACADEMY_POSTS";
export const GET_ACADEMY_POSTS_SEARCH = "GET_ACADEMY_POSTS_SEARCH";
export const GET_ACADEMY_PARTS = "GET_ACADEMY_PARTS";
export const GET_DETAIL_ACADEMY_PART = "GET_DETAIL_ACADEMY_PART";
export const CREATE_ACADEMY_SUBSCRIBE_EMAIL = "CREATE_ACADEMY_SUBSCRIBE_EMAIL";
export const GET_ACADEMY_FAQS = "GET_ACADEMY_FAQS";
export const GET_ACADEMY_MEMBERSHIP = "GET_ACADEMY_MEMBERSHIP";
export const GET_ACADEMY_SECTIONS = "GET_ACADEMY_SECTIONS";
export const GET_ACADEMY_HOME = "GET_ACADEMY_HOME";

// Discount
export const GET_MY_DISCOUNTS = "GET_MY_DISCOUNTS";
export const GET_DISCOUNT_BY_ID = "GET_DISCOUNT_BY_ID";
export const GET_DISCOUNT_PRODUCTS = "GET_DISCOUNT_PRODUCTS";
export const GET_DISCOUNT_ORDER_ITEMS = "GET_DISCOUNT_ORDER_ITEMS";

// Voucher
export const GET_MY_VOUCHERS = "GET_MY_VOUCHERS";
export const GET_VOUCHER_BY_ID = "GET_VOUCHER_BY_ID";
export const GET_VOUCHER_PRODUCTS_BY_VOUCHER_ID =
	"GET_VOUCHER_PRODUCTS_BY_VOUCHER_ID";
export const GET_VOUCHER_ORDER_ITEMS = "GET_VOUCHER_ORDER_ITEMS";

// Reskill
export const GET_RESKILLS = "GET_RESKILLS";
export const GET_MY_RESKILLS = "GET_MY_RESKILLS";
export const GET_RESKILL_PRODUCTS = "GET_RESKILL_PRODUCTS";
export const GET_MY_RESKILL_PRICE_PRODUCTS = "GET_MY_RESKILL_PRICE_PRODUCTS";
export const GET_RESKILL_ORDER_ITEMS = "GET_RESKILL_ORDER_ITEMS";
export const GET_RESKILL_PRICES = "GET_RESKILL_PRICES";
export const GET_RESKILL_LAYOFF_REQUEST_DISCOUNT =
	"GET_RESKILL_LAYOFF_REQUEST_DISCOUNT";
export const GET_MAIN_RESKILL = "GET_MAIN_RESKILL";
export const GET_RESKILL_PRICE_DOCUMENTS = "GET_RESKILL_PRICE_DOCUMENTS";

// Layoff
export const GET_LAYOFF_REQUESTS = "getLayoffRequests";
export const GET_LAYOFF_REQUEST_BY_ID = "getLayoffRequestById";
export const GET_LAYOFF_STATISTICS = "getLayoffStatistics";
export const GET_LATEST_REJECTED_LAYOFF_REQUEST_WITH_TIMELINE =
	"getLatestRejectedLayoffRequestWithTimeline";

//BLOG POS, PROJECT, NEWS
export const GET_BLOG_POSTS = "GET_BLOG_POSTS";
export const GET_BLOG_PROJECTS = "GET_BLOG_PROJECTS";
export const GET_POST_DETAIL = "GET_POST_DETAIL";
export const GET_BLOG_DETAIL = "GET_BLOG_DETAIL";

//BUSINESS
export const GET_BUSINESS_LIST = "GET_BUSINESS_LIST";

//Library

export const GET_LIBRARY_AND_RESOURCE_BY_LIBRARY_ID =
	"GET_LIBRARY_AND_RESOURCE_BY_LIBRARY_ID";
export const GET_LIBRARY_USAGE_IN_COURSES = "GET_LIBRARY_USAGE_IN_COURSES";
export const GET_ROOT_LIBRARY = "GET_ROOT_LIBRARY";
export const GET_ADMIN_ROOT_LIBRARY = "GET_ADMIN_ROOT_LIBRARY";

//resource
export const GET_LESSON_RESOURCE_BY_RESOURCE_ID =
	"GET_LESSON_RESOURCE_BY_RESOURCE_ID";
export const GET_RESOURCE_BY_ID = "GET_RESOURCE_BY_ID";
export const GET_RESOURCE_LINK = "GET_RESOURCE_LINK";
export const GET_RESOURCES_BY_IDS = "GET_RESOURCES_BY_IDS";

// Career Launchpad
export const GET_CAREER_LAUNCHPAD = "GET_CAREER_LAUNCHPAD";
export const GET_MY_CAREER_LAUNCHPAD = "GET_MY_CAREER_LAUNCHPAD";

// Survey
export const GET_SURVEYS = "GET_SURVEYS";
export const CREATE_SURVEY = "CREATE_SURVEY";
export const UPDATE_SURVEY = "UPDATE_SURVEY";
export const SOFT_CREATE_SURVEY = "SOFT_CREATE_SURVEY";
export const GET_SURVEY = "GET_SURVEY";
export const GET_SURVEYS_BY_PRODUCT = "GET_SURVEYS_BY_PRODUCT";
export const GET_SURVEY_SUBMISSIONS = "GET_SURVEY_SUBMISSIONS";
export const GET_SURVEY_LINKED_PRODUCTS = "GET_SURVEY_LINKED_PRODUCTS";

// Permission
export const GET_PERMISSIONS_BY_ROLE = "GET_PERMISSIONS_BY_ROLE";
export const GET_ALL_PERMISSIONS = "GET_ALL_PERMISSIONS";

/**
 * Learning Development
 */
export const GET_LEARNING_DEVELOPMENT_PAGE = "GET_LEARNING_DEVELOPMENT_PAGE";
export const GET_LEARNING_DEVELOPMENT_POSTS = "GET_LEARNING_DEVELOPMENT_POSTS";

/**
 * LMS
 */
export const GET_COMPETENCY_TECHNICAL_SKILL = "GET_COMPETENCY_TECHNICAL_SKILL";
export const GET_COMPETENCY_CORE_SKILL = "GET_COMPETENCY_CORE_SKILL";
export const GET_COMPETENCY_SKILL_LEVELS = "GET_COMPETENCY_SKILL_LEVELS";

/**
 * Edocument
 */
export const GET_E_DOCUTMENTS = "GET_E_DOCUTMENTS";

/**
 * Business Subscription Packages
 */
export const GET_ENTERPRISE_PLANS = "GET_ENTERPRISE_PLANS";
export const GET_AVAILABLE_ENTERPRISE_PLANS = "GET_AVAILABLE_ENTERPRISE_PLANS";
export const GET_ENTERPRISE_PLAN_BY_ID = "GET_ENTERPRISE_PLAN_BY_ID";

export const GET_ENTERPRISE_PAYMENTS = "GET_ENTERPRISE_PAYMENTS";
export const GET_ENTERPRISE_PAYMENT_DETAIL = "GET_ENTERPRISE_PAYMENT_DETAIL";

export const GET_PAYMENT_RECORDS_BY_EVENT_SLUG = "GET_PAYMENT_RECORDS_BY_EVENT_SLUG";
export const GET_PAYMENT_RECORD_COUNT = "GET_PAYMENT_RECORD_COUNT";
